export interface CommonDataInput {
    id?: string;
    tags?: string[];
    notes?: string;
    createdAt?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
    deletedAt?: string;
    deletedBy?: string;
    metadata?: Map<string, string>;
}

export class Common {
    public id?: string;
    public tags?: string[];
    public notes?: string;
    public createdAt?: string;
    public createdBy?: string;
    public updatedAt?: string;
    public updatedBy?: string;
    public deletedAt?: string;
    public deletedBy?: string;
    public metadata?: Map<string, string>;

    constructor(data: CommonDataInput) {
        this.id = data.id;
        this.tags = data.tags;
        this.notes = data.notes;
        this.createdAt = data.createdAt;
        this.createdBy = data.createdBy;
        this.updatedAt = data.updatedAt;
        this.updatedBy = data.updatedBy;
        if (data.deletedAt) {
            this.deletedAt = data.deletedAt;
        }
        if (data.deletedBy) {
            this.deletedBy = data.deletedBy;
        }
        this.metadata = new Map<string, string>();
        if (data.metadata) {
            Object.keys(data.metadata).forEach(key => {
                this.metadata.set(key, data.metadata[key]);
            });
        }
    }
}

export type PartialPick<T, K extends keyof T> = {
    [P in K]?: T[P];
};
